import * as React from 'react';
import { useHistory } from 'react-router-dom';
import {
  CardContainer,
  HeaderContainer,
  FooterContainer,
  CardDescription,
  CardTitle,
  BodyContainer,
  BlueRectangle,
  ServiceTreeNameText,
  InfoContainer,
  BodyLeftContainer,
  BodyDivider,
  NameLink,
  AddRequestLink,
} from '../../Common/Styles/homeCards.styled';
import { useGetConsumersForHome } from '../../Hooks/Home/useGetConsumersForHome';
import { DefaultButton, PrimaryButton, Spinner, SpinnerSize } from '@fluentui/react';
import { SubscriberRecord } from '../../Common/ConsumerModels/SubscriberRecord';

export function ConsumerCard(): React.ReactElement {
  const history = useHistory();

  const [consumerList, consumerListLoading] = useGetConsumersForHome();

  const handleViewAllConsumerButton = () => {
    history.push('/consumers');
  };

  const handleAddNewConsumerButton = () => {
    history.push('/consumers/addNew');
  };

  const renderNameLink = (consumer: SubscriberRecord) => {
    return (
      <NameLink
        to={`/consumers/${consumer.id}`}
        title=""
        target="_blank"
        usageEvent={{
          feature: 'HRDP',
          subFeature: 'HRDP.Home.Consumers',
        }}
      >
        {consumer.name}
      </NameLink>
    );
  };

  const renderAddRequestLink = (consumer: SubscriberRecord) => {
    return (
      <AddRequestLink
        to={`/consumers/${consumer.id}/addNew`}
        title=""
        target="_blank"
        usageEvent={{
          feature: 'HRDP',
          subFeature: 'HRDP.Home.Consumers',
        }}
      >
        Add Request
      </AddRequestLink>
    );
  };

  return (
    <>
      <CardContainer>
        <HeaderContainer>
          <CardTitle>Consumers</CardTitle>
          <CardDescription>
            The Consumer Onboarding Portal enables subscriber to onboard onto HR Data Platform and receive data.
          </CardDescription>
        </HeaderContainer>

        {consumerList.length > 0 &&
          consumerList.map((consumer: SubscriberRecord) => (
            <div key={consumer.id}>
              <BodyContainer>
                <BodyLeftContainer>
                  <BlueRectangle />
                  <InfoContainer>
                    {renderNameLink(consumer)}
                    <ServiceTreeNameText>{consumer.serviceTreeName}</ServiceTreeNameText>
                  </InfoContainer>
                </BodyLeftContainer>
                {renderAddRequestLink(consumer)}
              </BodyContainer>
              <BodyDivider />
            </div>
          ))}

        <FooterContainer>
          <PrimaryButton
            text={'View all Consumers'}
            disabled={consumerListLoading}
            onClick={handleViewAllConsumerButton}
            checked={false}
          />
          <DefaultButton
            text={'Add Consumer'}
            disabled={consumerListLoading}
            onClick={handleAddNewConsumerButton}
            checked={false}
          />
          {consumerListLoading && <Spinner size={SpinnerSize.medium} />}
        </FooterContainer>
      </CardContainer>
    </>
  );
}
